// Listing Description Strategy feedback questionnaire, same shape as
// pricingFeedbackConfig.js - consumed by the reusable <StrategyFeedback />
// component without any changes to that component. Seller-only Strategy, so
// unlike buildPricingFeedbackConfig this isn't a function of isBuyer.

export function buildListingDescriptionFeedbackConfig() {
  return {
    strategyType: "listingDescription",
    questions: [
      {
        id: "mlsAccuracy",
        type: "radio",
        required: true,
        prompt: "How accurately did the MLS description represent the property?",
        options: ["Very accurate", "Mostly accurate", "Some inaccuracies", "Significantly inaccurate", "Not sure"],
        followUp: {
          id: "mlsAccuracyIssues",
          type: "text",
          prompt: "What was inaccurate?",
          showWhen: (answers) => ["Some inaccuracies", "Significantly inaccurate"].includes(answers.mlsAccuracy),
        },
      },
      {
        id: "fairHousingReviewUseful",
        type: "radio",
        required: true,
        prompt: "Was the Fair Housing & Advertising Review useful?",
        options: ["Very useful", "Somewhat useful", "Not useful", "No concerns were flagged", "Not sure"],
      },
      {
        id: "researchUseful",
        type: "radio",
        required: false,
        prompt: "Did the property research identify helpful details you hadn't included?",
        options: ["Yes, several", "Yes, a few", "No", "Not sure"],
      },
      {
        id: "socialCaptionUseful",
        type: "radio",
        required: false,
        prompt: "How useful was the social media caption?",
        options: ["Very useful", "Somewhat useful", "Not useful", "Didn't review it"],
      },
      {
        id: "wouldPublishAsIs",
        type: "radio",
        required: true,
        prompt: "Would you publish one of these versions after only minor edits?",
        options: ["Yes, as-is", "Yes, with minor edits", "No, needs significant changes"],
        followUp: {
          id: "whatWouldChange",
          type: "text",
          prompt: "What would you change?",
          showWhen: (answers) => answers.wouldPublishAsIs === "No, needs significant changes",
        },
      },
      {
        id: "additionalComments",
        type: "text",
        required: false,
        prompt: "Anything else we should know?",
      },
    ],
  };
}
